import { render } from "./CrmProjectModal.vue?vue&type=template&id=d7b107be&scoped=true&ts=true&lang=pug"
import script from "./CrmProjectModal.vue?vue&type=script&lang=ts"
export * from "./CrmProjectModal.vue?vue&type=script&lang=ts"

import "./CrmProjectModal.vue?vue&type=style&index=0&id=d7b107be&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7b107be"]])

export default __exports__